import Snippet from '../../components/Snippet/Snippet'
import { loader } from '../../assets/code-snippets/loader/snip'
const Loader = () => {
    return <div className='container fluid py-2'>

        <div className="container fluid">
            <p className="text xl"><a href="#loaders" className="link">&#128279;</a> Loaders</p>
            <p className="text md gray"> Loaders are implemented into the website using HTML and CSS only for simplicity, in the code  snippets below is the code used for the loaders above, include the code lines into your HTML  document and have it up and running. </p>
        </div>

        <div className="row align-items-center">
            <div className="col md-III">
                <div className="container md">
                    <Snippet code={loader} language='html' />
                </div>

            </div>
            <div className="col md-III pt-3">

                <div className="container md space-around">

                    <div className="loader-spinner">
                        <div></div>
                        <div></div>
                    </div>

                    <div className="loader-bouncer">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>

                    <div className="loader-flipping-squares">
                        <div></div>
                        <div></div>
                    </div>
                </div>

            </div>
        </div>
    </div>
}
export default Loader